import { render, staticRenderFns } from "./CustomerMaterial.vue?vue&type=template&id=f1006dc4&scoped=true"
import script from "./CustomerMaterial.vue?vue&type=script&lang=js"
export * from "./CustomerMaterial.vue?vue&type=script&lang=js"
import style0 from "./CustomerMaterial.vue?vue&type=style&index=0&id=f1006dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1006dc4",
  null
  
)

export default component.exports